/**
 * Frontend-side env vars. Only VITE_* prefixed values are exposed to the
 * client bundle — they're inlined at build time.
 */
export const env = {
  /** Backend base URL. Empty string = same origin (production). */
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  /** Enable the dev-only form-login UI (only useful with the seeded admin/user accounts). */
  devLogin: import.meta.env.VITE_DEV_LOGIN === 'true',
} as const;
